module.exports = __webpack_public_path__ + "static/media/multi-image-4-mobile.a24f0ec3.png";